export default "<div class=\"markdown\">\r\n    <markdown [data]=\"license\"></markdown>\r\n</div>"